import React, { Dispatch, SetStateAction } from 'react';
import { Cart } from '@services/cart';

export interface CartContextValue {
  cart: Cart | null;
  setCart: Dispatch<SetStateAction<Cart | null>>;
  isCartDrawerOpen: boolean;
  setIsCartDrawerOpen: Dispatch<SetStateAction<boolean>>;
  toggleCartDrawer: () => void;
}

export const CartContext = React.createContext<CartContextValue>({
  cart: null,
  setCart: () => null,
  isCartDrawerOpen: false,
  setIsCartDrawerOpen: () => null,
  toggleCartDrawer: () => null,
});
